import { createLocalize } from "@uxf/localize";
import cs from "@uxf/localize/locale/cs";

export const {
    LocalizeProvider,
    FormatDateTime,
    FormatMoney,
    FormatPercentage,
    FormatNumber,
    formatDateTime,
    formatMoney,
    formatNumber,
    formatPercentage,
    useFormatDateTime,
    useFormatMoney,
    useFormatNumber,
    useFormatPercentage,
    useLocaleConfig,
} = createLocalize({ cs });
